<template>
    <transition name="el-fade-in-linear" style="position: relative">
        <div v-show="showMain" class="transition-box">
            <div id="formblock">
                <el-form label-position="top" label-width="80px" :model="searchForm">
                    <el-row :gutter="30">
                        <el-col :span="5">
                            <el-form-item label="餐飲平台">
                                <el-select v-model="searchForm.CUST_CODE" style="width:100%;" @change="getBrandOptions(searchForm.CUST_CODE); searchForm.BRAND_NAME='';">
                                    <el-option key="ALL" label="ALL" value=""></el-option>
                                    <el-option v-for="item in custOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="品牌">
                                <el-select v-model="searchForm.BRAND_NAME" clearable filterable allow-create style="width:100%;">
                                    <el-option key="ALL" label="ALL" value=""></el-option>
                                    <el-option v-for="item in brandOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="門店名稱/代號">
                                <el-input v-model="searchForm.VENDOR" style="width:100%;"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-row>
                                <el-form-item>
                                    <el-checkbox v-model="searchForm.SHOW_INCOME" label="僅顯示有儲值紀錄者" name="SHOW_INCOME" true-label="Y" false-label="N" />
                                </el-form-item>
                            </el-row>
                            <el-row>
                                <el-form-item>
                                    <el-checkbox v-model="searchForm.SHOW_ALERT" label="僅顯示低於儲值金警示水位" name="SHOW_ALERT" true-label="Y" false-label="N" />
                                </el-form-item>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row type="flex" justify="center">
                    <el-col :span="6" style="margin-top: auto; margin-bottom: auto;">
                        <el-button style="width: 100%" type="primary" @click="onSearch" v-show="store.getters.check_auth('SEARCH')">Search</el-button>
                    </el-col>
                </el-row>
            </div>
            <div id="datablock" style="height: calc(100vh - 352px)">
                <el-row type="flex" justify="end">
                    <el-button type="primary" round plain @click="onAddClick" v-show="store.getters.check_auth('ADD')">新增</el-button>
                    <el-button type="primary" round plain @click="onExportClick" v-show="store.getters.check_auth('PRINT')">下載明細</el-button>
                </el-row>

                <div ref="table" style="margin-top:10px;"></div>

            </div>
        </div>
    </transition>
</template>

<script setup>
    import { ref, reactive, onBeforeMount, onMounted, nextTick } from 'vue';
    import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
    import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
    import { useDownload } from '@/composables/download'
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    const store = useStore();

    const showMain = ref(true);//顯示主頁面
    const dialogTitle = ref('');//dialog標題
    const dialogFormVisible = ref(false);//顯示dialog
    const IDdisabled = ref(false);//編輯時ID狀態
    const addOrEdit = ref('');
    const formData = ref(null);
    const remitRef = ref(null);  //[明細/匯款紀錄]

    const table = ref(null); //reference to your table element
    const tabulator = ref(null); //variable to hold your table

    //下拉選單

    const searchForm = reactive({
        CUST_CODE: '',    // 餐飲平台
        BRAND_NAME: '',   // 品牌
        VENDOR: '',       // 門店名稱/代號
        SHOW_INCOME: '',
        SHOW_ALERT: '',
        type: 'list',
    });

    const onSearch = () => {
        onLoadTable();
    }

    const onLoadTable = () => {
        $api.GET('/api/Outlet/GetDepositTableData', {
            CUST_CODE: searchForm.CUST_CODE, BRAND_NAME: searchForm.BRAND_NAME, VENDOR: searchForm.VENDOR, SHOW_INCOME: searchForm.SHOW_INCOME, SHOW_ALERT: searchForm.SHOW_ALERT
        }).then((response) => {
            tabulator.value.setData(response);
        });
    }

    const onExportClick = () => {
        $api.POST('/api/Outlet/ExportExcel', {
            CUST_CODE: searchForm.CUST_CODE, BRAND_NAME: searchForm.BRAND_NAME, VENDOR: searchForm.VENDOR, SHOW_INCOME: searchForm.SHOW_INCOME, SHOW_ALERT: searchForm.SHOW_ALERT, type: 'deposit'
        }).then((response) => {
            useDownload('/api/Home/DownloadFile?URL_ADDR=' + response, response.split('\\')[1]);
        });
    }

    const getOptions = () => {
        getCustCodeOptions();
    }

    const custOptions = ref([]);
    const getCustCodeOptions = () => { // 取得[餐飲平台]下拉
        $api.GET('/api/Outlet/GetCustCodeOptions', {
        }).then((response) => {
            custOptions.value = response;
        });
    }

    const brandOptions = ref([]);
    const getBrandOptions = (CUST_CODE) => { // 取得[品牌]下拉
        $api.GET('/api/Outlet/GetBrandNameOptions', {
            CUST_CODE: CUST_CODE
        }).then((response) => {
            brandOptions.value = response;
        });
    }

    onMounted(() => {
        getOptions();
        //instantiate Tabulator when element is mounted
        tabulator.value = new Tabulator(table.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "calc(100vh - 392px)", //do not let table get bigger than the height of its parent element
            columnHeaderVertAlign: "middle", //align header contents to middle of cell
            headerVisible: true,
            pagination: true,       //paginate the data
            paginationSize: 50,         //allow 50 rows per page of data
            paginationSizeSelector: [50, 100, 200],
            reactiveData: true, //enable data reactivity
            columns: [
                { title: "序號", formatter: "rownum", width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "餐飲平台", field: "CUST_NAME", width: 100, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "品牌", field: "BRAND_NAME", headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: true },
                { title: "門店名稱", field: "NAME", headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: true },
                { title: "屬性", field: "ROLE_TYPE", width: 80, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "門店代號", field: "VENDOR_ID", width: 100, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: true },
                { title: "付款對象", field: "PAY_PARTY", width: 90, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "付款代號", field: "PAY_VENDOR", width: 100, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: true },
                { title: "儲值總額", field: "INCOME_AMT", width: 80, headerHozAlign: "center", hozAlign: "right", vertAlign: "middle", headerSort: false },
                { title: "外送運費", field: "DELIVERY_AMT", width: 80, headerHozAlign: "center", hozAlign: "right", vertAlign: "middle", headerSort: false },
                { title: "儲值餘額", field: "BAL_AMT", width: 80, headerHozAlign: "center", hozAlign: "right", vertAlign: "middle", headerSort: false },
                {
                    title: "儲值警示", field: "ALERT_AMT", width: 80, headerHozAlign: "center", hozAlign: "right", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                { title: "在途運費", field: "HOLD_AMT", width: 80, headerHozAlign: "center", hozAlign: "right", vertAlign: "middle", headerSort: false },
                { title: "最後交易日期", field: "LAST_TRN_TIME", width: 150, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
            ],
            rowFormatter: function (row) {
                let data = row.getData();
                if (data.ALERT_AMT != null) {
                    let BAL_AMT = 0;
                    if (data.BAL_AMT != null) BAL_AMT = parseInt(data.BAL_AMT.replace(',', ''));
                    let ALERT_AMT = data.ALERT_AMT;

                    if (BAL_AMT < ALERT_AMT) {
                        row.getElement().style.backgroundColor = "orange";
                    }
                }
            },
            langs: {
                "zh-tw": {
                    "pagination": {
                        "page_size": "選擇筆數",
                        "first": "第一頁",
                        "last": "最後一頁",
                        "prev": "上一頁",
                        "next": "下一頁",
                    }
                }
            },
        });

        //tabulator.value.on("tableBuilt", function () {

        //});
    });

</script>

<style>
</style>
